export const INTEREST_SET_STATISTIC = 'INTEREST_SET_STATISTIC';
